import { useEffect } from 'react';
import { useAppDispatch, useAppState } from '@/store';
import { getLLMTemplateVariables, selectLLMTemplateVariables, selectLLMTemplateVariablesIsLoading } from '../feature';

export const useGetLLMTemplateVariables = () => {
  const isLoading = useAppState(selectLLMTemplateVariablesIsLoading);
  const variables = useAppState(selectLLMTemplateVariables);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (variables) return;
    dispatch(getLLMTemplateVariables());
  }, [variables, dispatch]);

  return {
    isLoading,
    variables,
  };
};
